import { Debounce } from 'angular-debounce-throttle';
import { ApiService } from 'src/app/api.service';
import { ThemingService } from 'src/app/theming.service';
import { AppComponent } from 'src/app/app.component';
import { Component, OnInit} from '@angular/core';
import { ExportClientsService } from 'src/app/export-clients.service';
import { AuthService } from 'src/app/auth.service';
import { LambdaService } from 'src/app/lambda.service';
declare let $: any;

@Component({
  selector: 'app-consult-clients',
  templateUrl: './consult-clients.component.html',
  styleUrls: ['./consult-clients.component.scss']
})
export class ConsultClientsComponent implements OnInit {
  constructor(
    public appComponent: AppComponent,
    private apiService: ApiService,
    public themingService: ThemingService,
    private exportClientsService: ExportClientsService,
    private authService: AuthService,
    public lambdaService: LambdaService
  ) {}

  client: any;
  searchString: string = '';

  saleInfo: any;
  dataStatus = 2;

  Math = Math;

  loading: boolean = false;
  modalDelete = false;
  permissions: any = {};
  usersAndBeneficiaries: any[] = [];
  groupedOrders: any[] = [];
  expandedTabs: { [key: string]: { conditions: boolean, beneficiaries: boolean } } = {};

  // Propiedades para paginación
  currentPage: number = 1;
  itemsPerPage: number = 6;
  totalPages: number = 0;
  paginatedOrders: any[] = [];

  // Propiedades para el feedback del botón
  itemLoading: { [key: string]: boolean } = {};
  itemMessages: { [key: string]: { type: 'success' | 'error', message: string } | null } = {};

  ngOnInit(): void {
    this.authService.getUserPermissions().then((permissions) => {
      this.permissions = permissions || {};
    });
  }

  @Debounce(500)
  serchClient() {
    this.getClient();
  }

  async getClient() {
    this.loading = true;
    this.groupedOrders = [];
    this.paginatedOrders = [];
    this.client = [];
    try {
      const data: any = await this.lambdaService.getClientByNationalId(
        this.themingService.shopId,
        this.searchString
      );
      
      this.client = data.data[0];
      console.log("client by nationalId data: ", this.client);
      this.dataStatus = this.client.result == 0 ? 0 : 1;
      
      // Agrupar items por saleId
      if (this.client && this.client.items) {
        this.groupOrdersBySaleId();
      }
    } catch (error) {
      console.log(error);
    }
    this.loading = false;
  }

  groupOrdersBySaleId() {
    const ordersMap = new Map();
    
    this.client.items.forEach((item: any) => {
      if (!ordersMap.has(item.saleId)) {
        ordersMap.set(item.saleId, {
          saleId: item.saleId,
          saleDate: item.saleDate || new Date(),
          items: []
        });
      }
      ordersMap.get(item.saleId).items.push(item);
    });

    // Convertir a array y ordenar por saleId (más alto primero)
    this.groupedOrders = Array.from(ordersMap.values()).sort((a, b) => {
      return Number(b.saleId) - Number(a.saleId); // Descendente
    });

    // Calcular total de páginas
    this.totalPages = Math.ceil(this.groupedOrders.length / this.itemsPerPage);
    
    // Aplicar paginación
    this.applyPagination();
  }

  applyPagination() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedOrders = this.groupedOrders.slice(startIndex, endIndex);
  }

  changePage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.applyPagination();
    
    // Scroll suave al inicio de las órdenes
    setTimeout(() => {
      const ordersContainer = document.querySelector('.orders-container');
      if (ordersContainer) {
        ordersContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.changePage(this.currentPage + 1);
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.changePage(this.currentPage - 1);
    }
  }

  // Método para obtener array de páginas para mostrar
  getPagesArray(): number[] {
    const pages: number[] = [];
    const maxVisiblePages = 5;
    
    let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);
    
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  }

  getTimeElapsed(dateString: string): string {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - date.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    const years = Math.floor(diffDays / 365);
    const months = Math.floor((diffDays % 365) / 30);
    const days = diffDays % 30;
    
    let parts = [];
    if (years > 0) parts.push(`${years} ${years === 1 ? 'año' : 'años'}`);
    if (months > 0) parts.push(`${months} ${months === 1 ? 'mes' : 'meses'}`);
    if (days > 0) parts.push(`${days} ${days === 1 ? 'día' : 'días'}`);
    
    return parts.length > 0 ? `Hace ${parts.join(' ')}` : 'Hoy';
  }

  toggleTab(saleId: string, tab: 'conditions' | 'beneficiaries') {
    if (!this.expandedTabs[saleId]) {
      this.expandedTabs[saleId] = { conditions: false, beneficiaries: false };
    }
    this.expandedTabs[saleId][tab] = !this.expandedTabs[saleId][tab];
  }

  isTabExpanded(saleId: string, tab: 'conditions' | 'beneficiaries'): boolean {
    return this.expandedTabs[saleId] ? this.expandedTabs[saleId][tab] : false;
  }

  async discountSesion(item: any) {
    const itemId = this.getItemId(item);
    console.log('Item recibido:', item);
    console.log('Item recibido:', itemId);

    // Iniciar estado de loading
    this.itemLoading[itemId] = true;
    this.itemMessages[itemId] = null; // Limpiar mensajes previos

    try {
      const data: any = await this.lambdaService.discountItemSession(
        this.themingService.shopId,
        item.saleId,
        item.itemId,
        this.client.nationalId
      );

      console.log("Respuesta discountItemSession:", data);

      // Verificar si la operación fue exitosa
      if (data && data.done === true) {
        // Éxito
        this.itemMessages[itemId] = {
          type: 'success',
          message: '¡Sesión descontada exitosamente!'
        };
        // Actualizar item.bookingSessions de ese item específico sin recargar todo el cliente (opcional) y que se actualice en el frontend inmediatamente
        if (this.client && this.client.items) {
          const updatedItem = this.client.items.find((i: any) => i.saleId === item.saleId && i.itemId === item.itemId);
          if (updatedItem) {
            updatedItem.bookingSessions = updatedItem.bookingSessions+1; 
          }
        }

        // Limpiar mensaje después de 3 segundos
        setTimeout(() => {
          this.itemMessages[itemId] = null;
        }, 3000);
      } else {
        // Error en la respuesta
        throw new Error('La operación no se completó correctamente');
      }
    } catch (error) {
      console.log('Error al descontar sesión:', error);
      
      // Mostrar mensaje de error
      this.itemMessages[itemId] = {
        type: 'error',
        message: 'Error al descontar sesión. Intente nuevamente.'
      };

      // Limpiar mensaje después de 5 segundos
      setTimeout(() => {
        this.itemMessages[itemId] = null;
      }, 5000);
    } finally {
      // Finalizar loading
      this.itemLoading[itemId] = false;
    }
  }

  // Método para validar si condiciones tiene contenido real
  hasValidConditions(conditions: string): boolean {
    if (!conditions) return false;
    
    // Remueve tags HTML y espacios en blanco
    const textContent = conditions.replace(/<[^>]*>/g, '').trim();
    
    // Retorna true si hay texto significativo
    return textContent.length > 0;
  }

  // Método para validar si hay beneficiarios
  hasValidBeneficiaries(beneficiaries: any[]): boolean {
    return Array.isArray(beneficiaries) && beneficiaries.length > 0;
  }

  // Método para validar si un item tiene al menos una sección válida
  hasValidSections(item: any): boolean {
    const hasConditions = this.hasValidConditions(item.productConditions);
    const hasBeneficiaries = this.hasValidBeneficiaries(item.beneficiaries);
    return hasConditions || hasBeneficiaries;
  }

  // Método para generar ID único del item
  getItemId(item: any): string {
    return `${item.saleId}_${item.itemId}`;
  }

  notVerified() {
    $('#errorClientsModal').modal('show');
  }

  closeModal() {
    $('#errorClientsModal').modal('hide');
    $('#deleteClientModal').modal('hide');
  }
}